export default {"src":"/_next/static/media/Cooper-Ray3.f6dcb5fa.JPG","height":430,"width":646};